import { useLocation } from "react-router";
import { Home, LayoutDashboard, User, Users } from "lucide-react";
import { SidebarShell, SidebarNavItem } from "./SidebarShell";
import { UserMenu } from "./UserMenu";

const navItems = [
  { href: "/", label: "Home", icon: Home },
  { href: "/projects", label: "Projects", icon: LayoutDashboard },
  { href: "/affiliate", label: "Affiliate", icon: Users },
  { href: "/account", label: "Account", icon: User },
];

export function Sidebar() {
  const location = useLocation();

  return (
    <SidebarShell
      bottom={<UserMenu />}
    >
      {navItems.map((item) => (
        <SidebarNavItem
          key={item.href}
          href={item.href}
          label={item.label}
          icon={item.icon}
          isActive={
            item.href === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(item.href)
          }
        />
      ))}
    </SidebarShell>
  );
}
